import '@mantine/core/styles.css'
import './App.css';
import Home from './screens/Home';
import theme from './Theme';
import { BrowserRouter } from 'react-router-dom';
import {ThemeProvider} from '@mui/material/styles';
import {MantineProvider} from "@mantine/core";
import ScrollToTop from "./scripts/ScrollToTop";
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      offset: 80,
      easing: 'ease-out-cubic',
      once: false,
    });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="App ">
      
        <BrowserRouter>
            <MantineProvider>
                <ScrollToTop/>
                <Home/>
            </MantineProvider>
        </BrowserRouter>
      
      </div>
    </ThemeProvider>
  );
}

export default App;
